import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'
import casos from '../casos'
import i18n from '../../i18n'

import axios from '@/plugins/axios'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

import { toLocale } from '@/util/dateutils'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'contacto',
    ...crudState(),

    correoTipos: [{ id: 0, value: 'contacts.personal' }, { id: 1, value: 'contacts.job' }, { id: 2, value: 'contacts.other' }],
    telefonoTipos: [{ id: 0, value: 'contacts.personal' }, { id: 1, value: 'contacts.job' }, { id: 2, value: 'contacts.other' }],
    searchContacto: false,
    filtroBuscar: '',
    allContactos: [],
    paginationContactos: {},
    miembrosCuentasSE: [],
    paginationContactKeep: {}, // Para mantener la paginacion si esta volviendo de detalle del contacto
    searchContactKeep: '',
    routerSearch: '',
    storeSearch: '',
    expanded: false
  }),
  getters: {
    ...crudGetters,

    correoTipos: state => state.correoTipos,
    telefonoTipos: state => state.telefonoTipos,
    allContactos: state => state.allContactos,
    paginationContactos: state => state.paginationContactos,
    miembrosCuentasSE: state => state.miembrosCuentasSE,
    paginationContactKeep: state => state.paginationContactKeep, /// / Para mantener la paginacion si esta volviendo de detalle del contacto
    searchContactKeep: state => state.searchContactKeep,
    routerSearch: state => state.routerSearch,
    storeSearch: state => state.storeSearch,
    expanded: state => state.expanded
  },
  mutations: {
    ...crudMutations,
    setSearchContacto (state, value) {
      state.searchContacto = value
    },
    setFiltroBuscar (state, value) {
      state.filtroBuscar = value
    },
    setAllContactos (state, value) {
      state.allContactos = value
    },
    setPaginationContactos (state, data) {
      state.paginationContactos = data
    },
    setMiembrosCuentasSE (state, data) {      
      if (data.action === 'add') {
        state.miembrosCuentasSE = data.value
      } else {
        state.miembrosCuentasSE.splice(data.value, 1)
      }
    },
    setPaginationContactKeep (state, value) { // Para mantener la paginacion si esta volviendo de detalle del contacto
      state.paginationContactKeep = value
    },
    setSearchContactKeep (state, value) {
      state.searchContactKeep = value
    },
    setRouterSearch (state, value) {
      state.routerSearch = value
    },
    setStoreSearch (state, value) {
      state.storeSearch = value
    },
    setExpand (state, value) {
      state.expanded = value
    }
  },
  actions: {
    ...crudActions,
    async recuperarpass ({ commit, state }, params) {
      commit('setLoading', 1, { root: true })
      try {
        const response = await axios.post(`${state.endpoint}/recovery`, params)
        const message = get(response, 'data.message', {})
        const data = get(response, 'data.data', {})
        commit('setLoading', -1, { root: true })

        data.message = message
        return data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    },
    async getAllContactos ({ commit, state }, params) {
      const force = get(params, 'force', false)
      const query = get(params, 'query', {})

      if (force || !state.fetched || isEmpty(state.allContactos)) {
        commit('setLoading', 1, { root: true })
        try {
          const response = await axios.get(`${state.endpoint}/get`, { params: query })
          const data = get(response, 'data.data', [])
          const pagination = get(response, 'data.pagination', [])
          commit('setLoading', -1, { root: true })
          commit('setAllContactos', data)
          commit('setPaginationContactos', pagination)

          return data
        } catch (e) {
          commit('setLoading', -1, { root: true })
          return Promise.reject(e)
        }
      }
    },
    async getByContacts ({ commit, state }, params) {
      commit('setLoading', 1, { root: true })
      try {
        const response = await axios.get(`${state.endpoint}/getby`, { params: { id: params } })
        const data = get(response, 'data.data', {})        
        commit('setOne', data)
        commit('setLoading', -1, { root: true })

        return isEmpty(data) ? Promise.reject(new Error()) : data
      } catch (e) {
        commit('setLoading', -1, { root: true })
        return Promise.reject(e)
      }
    }
  },
  modules: {
    casos
  }
}
